export default class Direction {
  public static readonly SET_LIST = "STAND_DIRECTION_SET_LIST";
  public static readonly SET_STATUS = "STAND_DIRECTION_SET_STATUS";
  public static readonly SET_ERROR = "STAND_DIRECTION_SET_ERROR";
  public static readonly CLEAR = "STAND_DIRECTION_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: Direction.SET_LIST,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: Direction.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: Direction.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: Direction.CLEAR,
    };
  }
}
